import React, {useState,useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from 'react-select';
import { getActesProviderAction, createActesProviderAction, updateActesProviderAction, deleteActesProviderAction, searchActesAction, listProvidersAction, importActesPrestataireFileUploadAction, startLoader } from '../../../../store/actions/ProviderActions';
import swal from 'sweetalert';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import {Spinner, Button} from 'react-bootstrap';
import { Button as PButton } from 'primereact/button';
import { DataTableBase } from '../../DataTables/DataTableBase';
import { currentUser } from "../../../../store/selectors/CurrentUserSelector";
import { useTranslation } from "react-i18next";


const ActePrestataire = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let errorsObj = { acte: '', code: '' };
    const [id, setId] = useState('');
    const [code, setCode] = useState('');
    const [name, setName] = useState('');
    const [providerId, setProviderId] = useState('');
    const [providerName, setProviderName] = useState('');
    const [acteId, setActeId] = useState('');
    const [typeActe, setTypeActe] = useState('');
    const [errors, setErrors] = useState(errorsObj);
    //Modal box
    const [addCard, setAddCard] = useState(false);

    const [filters, setFilters] = useState(null);
    const [updateMode, setUpdateMode] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [file, setFile] = useState(null);

    const actTypes = [
        {label: "Chirugie", value: "Chirugie"},
        {label: "Consultation", value: "Consultation"},
        {label: "Imagerie", value: "Imagerie"},
        {label: "laboratoire", value: "laboratoire"},
        {label: "pharmacie", value: "pharmacie"},
        {label: "soinsdentaire", value: "soinsdentaire"},
        {label: "Autres", value: "Autres"},
    ]

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            providerName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            acteId: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            typeActe: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue("");
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                <PButton type="button" icon="pi pi-filter-slash"  label={t('common.reinit')} outlined onClick={clearFilter} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => onGlobalFilterChange(e)}  placeholder={t('common.search')} />
                </span>
            </div>
        );
    };

    const clearFilter = () => {
        initFilters();
    };

    const setColumns = () => {
        return [
            {name: 'id', headerName: "Id", style: { minWidth: '12rem' }, filter: false, bodyTemplate: null},
            {name: 'typeActe', headerName: t('client.type'), filterPlaceholder: t('provider.type-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'code', headerName: t('provider.act-code'), filterPlaceholder: t('provider.code-act-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'name', headerName: t('provider.nom-acte'), filterPlaceholder: t('provider.name-act-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'providerName', headerName: t('common.provider'), filterPlaceholder: t('provider.code-act-prod-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'acteId', headerName: t('common.act-acare'), filterPlaceholder: t('provider.name-act-prod-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '6rem'}, filter: false, bodyTemplate: getActionsTemplate},
        ]
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const getActionsTemplate = (rowData) => {
        return <div style={{ width: '100%', display: 'flex', justifyContent: 'center'}}>
            {hasMenu('MENPARAM') && canDo('MENPARAM', 'UPDATESTANDACT') && <Link href="#" to="#" onClick={e => updateData(rowData)} className="mr-4" title="Edit">
                <i className="fa fa-pencil color-muted"></i>
            </Link>}
            {hasMenu('MENPARAM') && canDo('MENPARAM', 'DELETESTANDACT') && <Link href="#" to="#" title="Close"
                onClick={() =>
                    swal({
                        title: t('client.delete-standart-act')+rowData.acteName+" ?",
                        text: t('client.delete-message'),
                        icon: "warning",
                        buttons: true,
                        dangerMode: true,
                    }).then((willDelete) => {
                        if (willDelete) {
                            dispatch(startLoader());
                            dispatch(deleteActesProviderAction(rowData.id));
                        }
                    })
                    }>
                <i className="fa fa-close color-danger"></i>
            </Link>}
        </div>
    }

    const updateData = (data) => {
        setId(data.id);
        setCode(data.code);
        setName(data.name);
        setActeId(data.acteId);
        setProviderId(data.providerId);
        setProviderName(data.providerName);
        setTypeActe(data.typeActe);
        setAddCard(true);
        setUpdateMode(true);
    }

    function selectFile(event) {
        setFile(event.target.files[0])
    }

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
            return false;
        }else{
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

    useEffect(() => {
        dispatch(startLoader());
        initFilters();
        dispatch(getActesProviderAction());  
        dispatch(listProvidersAction());    
    }, []);


    useEffect(() => {
        setUpdateMode(false);
        setId("");
        setCode("");
        setName("");
        setActeId("");
        setProviderId("");
        setProviderName("");
        setTypeActe("");
        setAddCard(false);  
    }, [props.actesProvider]);
    
    function onLettreCleSave(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        
        if(file){
            dispatch(startLoader());
            dispatch(importActesPrestataireFileUploadAction(file));
            return ;
        }

        if (code === '') {
            errorObj.acteCode = t('common.acte-error');
            error = true;
        }
        if (acteId === '') {
            errorObj.acteProdCode = t('common.acte-prod-error');
            error = true;
        }
        if (typeActe === '') {
            errorObj.typeActe = t('common.type-error');
            error = true;
        }

        setErrors(errorObj);
        if (error) {
            swal('Oops', t('common.check-form-fields'), "infos");
            return ;
        }
        dispatch(startLoader());
        

        if(updateMode) {
            let obj = [{ typeActe, code, name, acteId, providerName, providerId }];
            dispatch(startLoader());
            dispatch(updateActesProviderAction(id, obj));
        }else{
            let obj = [{ typeActe, code, name, acteId, providerName, providerId }];
            console.log(obj);
            dispatch(startLoader());
            dispatch(createActesProviderAction(obj));
        }
    }


    return (
        <>
            <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
                <div className="mr-auto d-none d-lg-block">
                    {hasMenu('MENPARAM') && canDo('MENPARAM', 'CREATESTANDACT') && <Link
                        to="#"
                        className="btn btn-primary btn-rounded"
                        onClick={() => setAddCard(true)}
                    >
                        + {t('common.new-provider-act')}
                    </Link>}
                </div>
            </div>
            <Modal className="modal fade" show={addCard} onHide={setAddCard} >
            <div className="">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">{t('common.create-provider-act')}</h4>
                    </div>
                    <div className='card-body'>
                        <div className='basic-form'>
                            <form onSubmit={onLettreCleSave}>
                                <div className='form-group col-12'>
                                    <label className='mb-1'>{t('provider.act-type')}</label>
                                    <Select
                                        className="select-search"
                                        value={actTypes.filter(elt => elt.value === typeActe)}
                                        placeholder={t("consultation.choose-type")}
                                        onChange={(val) => setTypeActe(val.value)}
                                        disabled={props.showLoading}
                                        required={props.showLoading}
                                        options={actTypes}
                                        style={{
                                            lineHeight: '40px',
                                            color: '#7e7e7e',
                                            paddingLeft: ' 15px',
                                        }}
                                    />
                                </div>

                                <div className='form-group col-12'>
                                    <label className='mb-1'>{t('common.code')}</label>
                                    <input
                                        type='text'
                                        name='code'
                                        className='form-control'
                                        placeholder='PH'
                                        value={code}
                                        disabled={props.showLoading}
                                        required={props.showLoading}
                                        onChange={(e) => setCode(e.target.value)}
                                    />
                                </div>
                                
                                <div className='form-group col-12'>
                                    <label className='mb-1'>{t('common.label')}</label>
                                    <input
                                        type='text'
                                        name='name'
                                        className='form-control'
                                        disabled={props.showLoading}
                                        required={props.showLoading}
                                        placeholder={t('layout.pharmacy')}
                                        value={name}
                                        onChange={(e) => {
                                            setName(e.target.value);
                                        }}
                                    />
                                </div>
                                
                                <div className='form-group col-12'>
                                    <label className='mb-1'>{t('common.act-acare')}</label>
                                    <Select
                                        className="select-search"
                                        value={props.actes.filter(act => act.id === acteId).map(elt => { return {label: elt.nameFr, value: elt.id}})}
                                        options={props.actes.map(elt => {return {label: elt.nameFr, value: elt.id}})}
                                         placeholder={t('common.choose')}
                                        search
                                        isRequired
                                        onInputChange={(val) => {
                                            if(val.length >= 3){
                                                dispatch(searchActesAction(val));
                                            }
                                        }}
                                        onChange={(val) => {
                                            setActeId(val.value);
                                        }}
                                    />
                                </div>

                                <div className='form-group col-12'>
                                    <label className='mb-1'>{t('common.provider')}</label>
                                    <Select
                                        className="select-search"
                                        value={{label: providerName, value: providerId}}
                                        options={props.providers.map(elt => {return {label: elt.providerName, value: elt.id}})}
                                         placeholder={t('dashboard.choose-provider')}
                                        search
                                        isRequired
                                        onChange={(val) => {
                                            setProviderName(val.label);
                                            setProviderId(val.value);
                                        }}
                                    />
                                </div>
                                <hr />
                                <div className='row text-center'>
                                    <h4 className='text-center'>{t("common.import-csv-act-pretataire")}</h4>
                                </div>
                                <div className='input-group mb-3'>
                                    <div className='input-group-prepend'>
                                        <span className='input-group-text'>CSV</span>
                                    </div>
                                    <div className='custom-file'>
                                        <input type='file' className='custom-file-input' onChange={selectFile} />
                                        <label className='custom-file-label'>{file ? file.name : t('common.choose-file')}</label>
                                    </div>
                                </div>
                                <div className='form-group align-items-center justify-content-center'>
                                    { props.showLoading && 
                                        <Button variant="primary" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />{' '}
                                            <span className="visually-hidden">{t('common.await-text')}</span>
                                        </Button> }
                                    { !props.showLoading &&
                                        <div className='col-4'>
                                            <button type='submit' className='btn btn-primary'>
                                               {t('common.save')}
                                            </button>
                                        </div> }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            </Modal>
            <DataTableBase 
                data={props.actesProvider.length > 0 ? props.actesProvider : []}
                emptyMessage={t('common.no-standart-act')} 
                filters={filters}
                globalFiltersFields={['id', 'code', 'name', 'providerName', 'acteId', 'typeActe']}
                header={renderHeader()}
                columns={setColumns()}
                exportColumns={[
                    { title: 'ID', dataKey: 'id' },
                    { title: t('common.act-type'), dataKey: 'typeActe' },
                    { title: t('common.act-name'), dataKey: 'name' },
                    { title: t('common.act-code'), dataKey: 'code' },
                    { title: t('common.provider'), dataKey: 'providerName' },
                    { title: t('common.act-acare'), dataKey: 'acteId' },
                ]}
                rows={10} 
                showExport={true}
                exportFilename={"actes_prestataire"}
                loading={props.showLoading}
                lazy={false}
            />

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        providers: state.provider.providers,
        actes: state.provider.actesRes,
        actesProvider: state.provider.actesProvider,
        errorMessage: state.clientAuth.errorMessage,
        successMessage: state.clientAuth.successMessage,
        showLoading: state.provider.showLoading,
        currentUser: currentUser(state)
    };
};

export default connect(mapStateToProps)(ActePrestataire);